import { Radio } from 'antd';
import { observer } from 'mobx-react';
import { summaryStore } from '../../store'; // 请根据实际路径调整

const ModelSelector = observer(() => {
    const wordCounts = [3000, 5000, 8000, 15000, 20000, 30000, 50000];

    return (
        <div className="mb-6 mt-4 flex w-full flex-col justify-start gap-4">
            {/* 字数选择保持不变 */}
            <div className="flex items-center gap-4">
                <span className="text-nowrap text-[#192038]">字数：</span>
                <div className="flex flex-wrap gap-4">
                    {wordCounts.map((count) => (
                        <span
                            key={count}
                            onClick={() => summaryStore.setWordCount(count)}
                            className={`cursor-pointer text-base ${
                                summaryStore.wordCount === count
                                    ? 'font-bold text-primary underline'
                                    : 'text-[#414C6F] hover:text-primary'
                            }`}
                        >
                            {count}
                        </span>
                    ))}
                </div>
            </div>

            {/* 模型选择 - Radio Group */}
            <div className="flex items-center gap-4">
                <span className="text-nowrap text-[#192038]">模型：</span>
                <Radio.Group
                    value={summaryStore.useUltra ? 'ULTRA' : 'NORMAL'}
                    onChange={(e) => {
                        if (
                            (e.target.value === 'ULTRA' && !summaryStore.useUltra) ||
                            (e.target.value === 'NORMAL' && summaryStore.useUltra)
                        ) {
                            summaryStore.toggleUseUltra();
                        }
                    }}
                >
                    <Radio value="NORMAL">学术模型</Radio>

                    <Radio value="ULTRA">
                        <div className="flex flex-wrap gap-0.5">
                            {' '}
                            {/* flex-wrap 防止小屏幕换行太难看 */}
                            {/* 图标保持不变 */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="#FFA346"
                                className="h-4 w-4 flex-shrink-0 translate-y-[3px]"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813a3.75 3.75 0 002.576-2.576l.813-2.846A.75.75 0 019 4.5z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            {/* 文字区域 */}
                            <div className="flex gap-1">
                                {/* 主标题 */}
                                <span className="bg-gradient-to-r from-[#FFA346] to-[#FF7A00] bg-clip-text font-semibold text-transparent">
                                    超级自研学术特调模型
                                </span>

                                {/* 括号说明 - 更加专业全面的文案 */}
                                <span className="translate-y-[3px] text-xs font-normal text-gray-500">
                                    (深度全维解析，图表等内容更专业)
                                </span>
                            </div>
                        </div>
                    </Radio>
                </Radio.Group>
            </div>
        </div>
    );
});

export default ModelSelector;
